import {combineReducers} from 'redux';

import overdose from './overdose-reducer';
import demographics from './demographics-reducer';
import dimensions from './dimensions-reducer';
import states from './states-reducer';
import counties from './counties-reducer';
import providers from './provider-reducer';

const rootReducer = combineReducers({
  dimensions,
  overdose,
  demographics,
  states,
  counties,
  providers
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js